import React from 'react'

import './style.css'

const Privacy = () => (
  <div className="search-container privacy">
    <h3>into Caerulus潛進蔚藍隱私權政策</h3>
    <p>
    into Caerulus潛進蔚藍網路平台（以下稱「本平台」）為蔚藍視界股份有限公司（以下稱「本公司」）所經營之B2B2C網站，提供會員向本平台網路開店商家（以下稱「個別商家」）購物服務。基於對您隱私權的保護，本公司及個別商家將依個人資料保護法及本隱私權政策共同蒐集、處理及利用您的個人資料，並提供您對個人資料權利之行使與保護。若您不同意本隱私權政策之全部或部分者，請您停止使用本平台服務。
    </p>
    <h4>1. 本隱私權政策適用之範圍</h4>
    <p>
    本隱私權政策適用於會員於本平台之使用及向個別商家購物所衍生之個人資料蒐集、處理及利用事宜。請於使用本平台服務前，確認您已審閱並同意本隱私權政策所列全部條款，若您不同意全部或部分者，請勿使用本平台服務。 您可能經由本平台連結至非本公司或個別商家以外之第三人所經營之網站或服務，各該網站所為之個人資料蒐集係依其網站之隱私權政策規定處理，與本公司或個別商家無涉。
    </p>
    <h4>2. 個人資料保護法應告知事項</h4>
    <p>
      <ul className="disc">
        <li>蒐集機關名稱：蔚藍視界股份有限公司及個別商家（個別商家名稱列於行程頁面）。</li>
        <li>蒐集目的：提供本公司及本平台會員相關服務、個別商家與會員間有關電子商務等相關行銷、契約、類似契約或其他法律關係事務、消費者、客戶管理與服務、網路購物及其他電子商務服務、廣告和商業行為管理業務、其他經營合於本公司營業登記項目或組織章程所定之業務。</li>
        <li>個人資料類別：識別類（姓名、身分證或護照號碼、地址、聯絡電話、電子郵件信箱）、特徵類（年齡、性別、出生年月日等）、過往活動經驗(有無潛水執照、有無潛水經驗等)、消費資料、其他（往來電子郵件、網站留言、系統自動紀錄之軌跡資訊等），惟將以實際本公司取得之個人資料為限。</li>
        <li>個人資料利用期間：本平台會員有效期間及終止後六個月；若非會員則於該蒐集個人資料之目的消失後六個月。</li>
        <li>個人資料利用地區：本公司執行業務及伺服器主機所在地。</li>
        <li>個人資料利用對象：本公司、各該交易之個別商家（個別商家無法取得非於該商家消費之資料）及電子商務相關協力廠商（例如：提供物流、金流或活動贈品、展示品之廠商）；如為本公司與其他廠商共同蒐集者，將於該共同蒐集之活動中載明。</li>
        <li>個人資料利用方式：依蒐集目的範圍及本隱私權政策進行利用。本公司限制個別商家於個別交易以外之情形向會員行銷，如有發現該等濫用個人資料之情事，請通知本公司。</li>
        <li>行使個人資料權利方式：依個人資料保護法第3條規定，您就您的個人資料享有查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除之權利。您可以透過寄送電子郵件至<a href="mailto:info@intocaerulus.com">【info@intocaerulus.com】</a>（為避免電子郵件系統漏信或其他原因無法收悉，以本公司回覆收悉為準）或以書面郵寄至【950台東縣台東市鐵花路82號2樓】方式行使上開權利，本公司將於收悉您的請求後儘速處理，並會代您將相關請求轉知個別商家一併處理。</li>
        <li>個人資料選填說明：若於蒐集個人資料時，相關網頁或文件載明為選填者，僅為提供您使用本平台更佳體驗，不影響您使用本平台之權益。</li>
      </ul>
    </p>
    <h4>3. 個人資料蒐集、處理及利用說明</h4>
    <p>
    本公司可能透過Facebook或類似社群服務系統，於取得您的同意後，將部分本平台的資訊發布於您的社群活動資訊頁面，若您不同意該等訊息之發布，請您勿點選同意鍵，或於事後透過各該社群服務之會員機制移除該等資訊或拒絕本平台繼續發布相關訊息。若有任何問題，仍可與本公司聯絡，本公司將協助您確認、處理相關問題。 若您所填寫之送貨地址、聯絡人、聯絡方式等非您本人之個人資料，您同意已取得各該當事人之同意提供予本公司，並已代表本公司就前開法定告知事項予以告知。 除依法應提供予司法、檢調機關、相關主管機關，或與本公司協力廠商為執行相關活動必要範圍之利用外，本公司將不會任意將您的個人資料提供予第三人。 當本公司或本平台全部或部分分割、獨立子公司經營、被其他第三者購併或收購資產，導致經營權轉換時，本公司會於事前將相關細節公告於本平台，且本公司或本平台所擁有之全部或部分使用者資訊亦可能在經營權轉換的狀況下移轉給第三人。惟限於與該經營權轉換服務相關之個人資料。若本公司或本平台部分營運移轉予第三人，您仍為本公司會員，若您不希望本公司後續利用您的個人資料，您可以依本隱私權政策向本公司行使權利。
    </p>
    <h4>4. Cookie技術</h4>
    <p>
    為便於日後的辨識，當您使用本平台服務時，本公司可能會在您的電腦或手持式設備上設定與存取Cookie或其他類似技術。 您可以透過設定您的個人電腦或手持式設備，決定是否允許Cookie或其他類似技術的使用，若您關閉Cookie或其他類似技術時，可能會造成您使用本平台服務時之不便利或部分功能限制。
    </p>
    <h4>5. 保密與安全性</h4>
    <p>
    本公司及個別商家之員工，僅於其為您提供產品或服務之需求範圍內，對於您的個人資料得為有限之接觸。 為了保護您的帳戶及個人資料的安全，請您不要任意將個人帳號、密碼提供予第三人或允許第三人以您的個人資料申請帳號、密碼，否則，相關責任由您自行負擔。若您的帳號、密碼有外洩之虞，請您立即更改密碼，或通知本公司暫停該帳號（本公司可能會要求核對您的個人資料）。 網際網路並不是一個安全的資訊傳輸環境，請您在使用本平台時，避免將敏感的個人資料提供予他人或在網站上公開揭露。
    </p>
    <h4>6. 未成年人保護</h4>
    <p>
    本平台並非特別為未成年人/兒童設計，未成年人使用本平台時，若同意本平台蒐集、利用其個人資訊時，應在法定代理人或監護人之同意下為之。法定代理人或監護人得隨時請求本公司停止特定帳號及其相關之個人資料之蒐集、處理及利用行為。
    </p>
    <h4>7. 隱私權政策之修改</h4>
    <p>
    隱私權政策如經修改，本平台將以您所提供之電子郵件或行動電話通知您相關之重大變更，並於本平台公告。若您不同意該等變更或修改，請停止繼續使用本平台服務，並依本隱私權政策規定通知本公司及個別商家停止蒐集、處理及利用您的個人資料。
    </p>
  </div>
)
export default Privacy


// WEBPACK FOOTER //
// ./src/containers/Privacy/index.js